import {inject, injectable} from "inversify";
import type {IHttpClientService, IApiResponse} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";

export interface IGeo {
	brand: string | null;
	country: string | null;
	logoDark: string | null;
	logoLight: string | null;
	state: string | null;
}
export interface IGeoApiProvider {
	geo: () => Promise<AxiosResponse<IApiResponse<{geo: IGeo}>>>;
}

@injectable()
export class GeoApiProvider implements IGeoApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	geo = () => this._http.get<IApiResponse<{geo: IGeo}>>("geo");
}
